module.exports = __webpack_public_path__ + "static/media/CoalIconWeb.3c310fbb.svg";